export default __webpack_public_path__ + "static/media/right-arrow-next-com.2ef67404.svg";